import StockEntry from "./StockEntry";
import StockDeduction from "./StockDeduction";
import StockReport from "./StockReport";
export default { StockEntry, StockDeduction, StockReport };
